import { create } from 'zustand';

interface TransitionState {
  active: boolean;
  setActive: (active: boolean) => void;
}

export const useTransitionStore = create<TransitionState>((set) => ({
  active: false,
  setActive: (active) => set({ active }),
}));
